import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultUserInfo } from '../interfaces/User'
import { useAuth } from './useAuth'

interface C101UserGetProps {
  execUserGet: (loginId: string, token?: string) => Promise<ResultUserInfo>
  loading: loadStatus
}
// C101 ユーザー取得API呼出
export const useC101UserGet = (): C101UserGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execUserGet = async (loginId: string, token?: string) => {
    try {
      setLoading(loadStatus.LOADING)

      // ヘッダ作成
      const jwt = token ? token : await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.get(`${baseUrl}${stage}${apiUrl.usersPath}${loginId}`, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execUserGet, loading }
}
